import React from 'react'

import { HeaderWrapper, StyledContainer } from './styles.js'

import Logo from './../../components/Logo'
import Navigation from './../../components/Navigation'
import ButtonMenu from './../../components/ButtonMenu'

class Header extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			prevScrollpos: typeof window !== 'undefined' ? window.pageYOffset : 0,
			visible: true,
			isTop: true
		};
	}

	componentDidMount() {
		
		window.addEventListener('scroll', this.handleScroll);

	}

	componentWillUnmount() {

		window.removeEventListener('scroll', this.handleScroll);

	}

	handleScroll = () => {

		const { prevScrollpos } = this.state;
		const currentScrollPos = window.pageYOffset;		
		const isTop = currentScrollPos < 100 ? true : false;

		let visible = prevScrollpos > currentScrollPos || prevScrollpos < 0 ? true : false;
		
		if (this.props.active) {
			visible = true;
		}
		
		this.setState({
			prevScrollpos: currentScrollPos,
			visible,
			isTop
		});

	};

	render() {
		
		const { theme, isMobile, onClick, active, page } = this.props;

		let navigationTheme;

		if (this.state.isTop) {
			navigationTheme = theme;
		} else if (!this.state.isTop) {
			navigationTheme = 'dark';
		}

		return (

			<HeaderWrapper theme={theme} isMobile={isMobile} menuActive={active} visible={!this.state.visible} isTop={this.state.isTop}>
				<StyledContainer>

					{isMobile ? <ButtonMenu onClick={onClick} theme={navigationTheme} active={active} /> : null}

					<Logo url={'/'} theme={navigationTheme} menuActive={active}/>
					<Navigation theme={navigationTheme} visible={!this.state.visible} isTop={this.state.isTop} page={page} />

				</StyledContainer>
			</HeaderWrapper>

		)
	}

}

export default Header